import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
// import { Delete } from "@material-ui/icons";
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
} from "@material-ui/core";
import {
  EditIcon,
  StarFill,
  StarOutline,
  ViewEye,
  Delete,
  GridHide,
  ListShow,
  ListHide,
  GridShow,
} from "../../../LeftNav/SvgIcons";
import { Pagination } from "../../../../../components/common";
import { GridFilterBarBusinessCustomers } from "../../BusinessConsumers/components";
import { EndUserOrderList } from "./EndUserOrderList";

const useStyles = makeStyles(theme => ({
  gridTopNav: {
    padding: "10px 0 10px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // minHeight: "23px",
  },
  deleteItems: {
    display: "flex",
    alignItems: "center",
  },
  gridHeaderInner: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "12px",
    paddingBottom: "9px",
  },
  gridHeader: {
    background: "#E5F2FF",
    borderRadius: "6px",
  },
  gridHeaderRow: {
    borderRadius: "6px",
  },
  checkBoxFont: {
    fontSize: "22px",
  },
  gridBodyInner: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "4px",
    paddingBottom: "4px",
  },
}));

const EndUserOrdersGrid = () => {
  const classes = useStyles();
  const [isOrderList, setOrderList] = useState(false);
  const [isOrderGrid, setIsOrderGrid] = useState(true);
  const [isFavourite, setIsFavourite] = useState(false);
  const [filterByName, setFilterByName] = useState("");
  const [selectedCategoryId, setSelectedCategory] = useState(null);
  const [businessGroups, setBusinessGroups] = useState([]);
  const [paginationResponse, setPaginationResponse] = useState({
    currentCount: 0,
    totalRecords: 0,
  });
  const [order, setOrderBy] = useState({
    orderByKey: "Id",
    orderVal: 0,
  });
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectedDate, setSelectedDate] = useState(0);

  const onMarkFavouriteCustomer = () => {
    setIsFavourite(!isFavourite);
  };

  const ShowOrderListView = () => {
    setIsOrderGrid(false);
    setOrderList(true);
  };

  const ShowOrderGridView = () => {
    setIsOrderGrid(true);
    setOrderList(false);
  };

  const data = [
    {
      orderid: "123456789",
      date: "4/8/2023",
      paymentstatus: "Pending",
      fulfillmentstatus: "Cancelled",
      ordertotal: "$100.23",
    },
    {
      orderid: "123456789",
      date: "4/8/2023",
      paymentstatus: "Cancelled",
      fulfillmentstatus: "Approved",
      ordertotal: "$100.23",
    },
    {
      orderid: "123456789",
      date: "4/8/2023",
      paymentstatus: "Approved",
      fulfillmentstatus: "Pending",
      ordertotal: "$100.23",
    },
  ];

  return (
    <div
      className='gridBody contentBody businessCustomerGrid activityGridSearch'
      style={{ width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GridFilterBarBusinessCustomers
            businessGroups={businessGroups}
            setFilterByName={setFilterByName}
            setSelectedCategory={setSelectedCategory}
            setSelectedDate={setSelectedDate}
          />
          {/* <span
            className='blockEndUserBtn gridFiltersButtons'
            style={{ marginTop: "20px" }}>
            <span onClick={ShowOrderGridView}>
              {isOrderGrid ? <GridShow /> : <GridHide />}
            </span>
            <span onClick={ShowOrderListView}>
              {isOrderGrid ? <ListHide /> : <ListShow />}
            </span>
          </span> */}
        </Grid>
      </Grid>
      <h2 className='gridInnerHeading'>ABX Company’s Orders</h2>
      <span className='gridPagination' style={{ marginTop: "18px" }}>
        <i>
          {page}-{rowsPerPage} of&nbsp;
          {paginationResponse?.totalRecords}
        </i>
      </span>

      <div className='gap' />
      {isOrderGrid && (
        <>
          <Table>
            <TableHead className={classes.gridHeader}>
              <TableRow className={classes.gridHeaderRow}>
                <TableCell className={classes.gridHeaderInner}>
                  Order ID #
                  {/* <TableSortLabel
                active={order.orderByKey === "CompanyName"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "CompanyName",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
              /> */}
                </TableCell>
                <TableCell className={classes.gridHeaderInner}>
                  Date
                  {/* <TableSortLabel
                active={order.orderByKey === "TotalUsers"}
                direction={order.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "TotalUsers",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
              /> */}
                </TableCell>
                <TableCell className={classes.gridHeaderInner}>
                  Payment Status
                </TableCell>
                <TableCell className={classes.gridHeaderInner}>
                  Fulfillment Status
                </TableCell>
                <TableCell className={classes.gridHeaderInner}>
                  Order Total
                </TableCell>
                <TableCell
                  className={(classes.gridHeaderInner, "quickLinkWrapper")}>
                  Quick Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((item, index) => {
                return (
                  <TableRow key={index} className='gridBodyRow endUserRow'>
                    <TableCell
                      className={classes.gridBodyInner}
                      style={{ color: "#3699ff", fontWeight: "700" }}>
                      {item.orderid}
                    </TableCell>
                    <TableCell className={classes.gridBodyInner}>
                      {item.date}
                    </TableCell>
                    <TableCell className={classes.gridBodyInner}>
                      <span
                        className={`${
                          (item.paymentstatus == "Pending" &&
                            "pendingStatus") ||
                          (item.paymentstatus == "Approved" &&
                            "approvedStatus") ||
                          (item.paymentstatus == "Cancelled" &&
                            "calceledStatus")
                        }`}>
                        {item.paymentstatus}
                      </span>
                    </TableCell>
                    <TableCell className={classes.gridBodyInner}>
                      <span
                        className={`${
                          (item.fulfillmentstatus == "Pending" &&
                            "pendingStatus") ||
                          (item.fulfillmentstatus == "Approved" &&
                            "approvedStatus") ||
                          (item.fulfillmentstatus == "Cancelled" &&
                            "calceledStatus")
                        }`}>
                        {item.fulfillmentstatus}
                      </span>
                    </TableCell>
                    <TableCell className={classes.gridBodyInner}>
                      {item.ordertotal}
                    </TableCell>
                    <TableCell
                      className={(classes.gridBodyInner, "quickLinkWrapper")}>
                      <div className='gridActions'>
                        <span onClick={onMarkFavouriteCustomer}>
                          {isFavourite ? <StarFill /> : <StarOutline />}
                        </span>
                        <span>
                          <EditIcon />
                        </span>
                        <span>
                          <ViewEye />
                        </span>
                        <span>
                          <Delete />
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Pagination
            recordCount={paginationResponse?.totalRecords}
            page={page - 1}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        </>
      )}

      {isOrderList && <EndUserOrderList />}
    </div>
  );
};

export default EndUserOrdersGrid;
